import { Link } from "react-router-dom";

export default function WishlistEmpty() {
  return (
    <div className="flex flex-col items-center justify-center py-28 text-center">
      {/* Icon */}
      <div className="w-20 h-20 flex items-center justify-center mb-6 border border-pearl/60 rounded-full">
        <i className="ri-heart-line text-3xl text-midnight/25" />
      </div>

      <h2
        className="text-2xl font-light text-midnight mb-3"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Your wishlist is empty
      </h2>
      <p className="text-sm text-midnight/45 max-w-xs leading-relaxed mb-8">
        Save pieces that catch your eye — tap the heart on any product to add it
        here for later.
      </p>

      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          to="/collections/new-arrivals"
          className="text-[11px] tracking-widest uppercase bg-midnight text-moonlight px-8 py-3 hover:bg-midnight/85 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          New Arrivals
        </Link>
        <Link
          to="/collections/clothes"
          className="text-[11px] tracking-widest uppercase border border-midnight text-midnight px-8 py-3 hover:bg-midnight hover:text-moonlight transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          Browse Clothes
        </Link>
      </div>
    </div>
  );
}
